import store from "../store";
import { getAppConfig } from "@/api/AppConfig";
export default {
  // 设置主题
  setTheme(themeConfig) {
    const root = document.documentElement;
    root.style.cssText = subsColorObj(themeConfig.merThemeColor).str;
    store.commit(
      "setAppData",
      Object.assign(
        {},
        themeConfig,
        subsColorObj(themeConfig.merThemeColor).obj
      )
    );
  },

  // 获取主题
  getTheme() {
    return JSON.parse(localStorage.getItem("themeConfig")) || {};
  },

  // 从后端获取主题配置
  async fetchTheme() {
    return new Promise((resolve) => {
      // 模拟网络延迟
      getAppConfig().then((res) => {
        resolve(res);
      });
    });
  },
};
// 辅助色  主题色0.1 -.09透明度
const subsColorObj = (color) => {
  let str = `--primary-color:${color};`;
  let obj = {};
  for (let i = 1; i <= 9; i++) {
    str += `--subs${i}-color:${hexToRgba(color, i / 10)};`;
    obj[`subs${i}color`] = hexToRgba(color, i / 10);
  }
  obj.themeColor = str;
  return {
    str,
    obj,
  };
};
// 将#xxxxxx色值转换为rgba格式
const hexToRgba = (hex, opacity) => {
  // 移除 # 符号
  hex = hex.replace("#", "");
  // 处理缩写形式（如 #fff → #ffffff）
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((c) => c + c)
      .join("");
  }
  // 解析为 R, G, B 值
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // 返回 RGBA 字符串
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
